import WebApi from './WebApi';
import { StorageKeys } from '../constants';
import { ExecutiveService } from './ExecutiveService';

export class AuthenticationService {
  static async login(loginResponse) {
    return await AuthenticationService.handleEmailLoginResponse(loginResponse);
  }

  static getLoggedUser() {
    const storageLoggedUser = sessionStorage.getItem(StorageKeys.AuthIdentity);
    if (!storageLoggedUser) return null;

    return JSON.parse(storageLoggedUser);
  }

  static async getLoggedExecutive(login) {
    const executive = await ExecutiveService.search(login);
    sessionStorage.setItem(
      StorageKeys.AuthExecutive,
      JSON.stringify(executive)
    );
    return executive;
  }

  static getAuthToken() {
    return sessionStorage.getItem(StorageKeys.AuthIdentity);
  }

  static userIsLogged() {
    return sessionStorage.getItem(StorageKeys.AuthIdentity);
  }

  static logout() {
    AuthenticationService.removeAuthFromStorage();
  }

  static removeAuthFromStorage() {
    localStorage.clear();
    sessionStorage.clear();
  }

  static updateLoggedUser(user) {
    localStorage.setItem(StorageKeys.LoggedUser, JSON.stringify(user));
  }

  static async handleEmailLoginResponse(loginResponse) {
    return await AuthenticationService.getUserInfo(loginResponse);
  }

  static async getUserInfo(loginResponse) {
    const executive = await ExecutiveService.search(loginResponse.profile.sub);

    sessionStorage.setItem(
      StorageKeys.AuthExecutive,
      JSON.stringify(executive)
    );
    return executive;
  }

  static storeAuthToken(token) {
    localStorage.setItem(StorageKeys.AuthToken, token);
  }
}
